// src/components/BGP/request/request.ts
import axios from "axios";

/** Determina la URL base de la API **/
const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:3000";
const API_V1_URL = `${API_BASE_URL}/v1`;

/** ========== BGP ========== **/
export function getNeighborsStatus(token: string, tenantId: number) {
    return axios.get(`${API_V1_URL}/ctxr/-1/statusneighbor?tenantId=${tenantId}`, {
        headers: { Authorization: `Bearer ${token}` },
    });
}

/** ========== CloudHealth ========== **/
export function getCloudHealth(token: string, tenantId: number) {
    return axios.get(`${API_V1_URL}/suscription/-1/CloudHealth?tenantId=${tenantId}`, {
        headers: { Authorization: `Bearer ${token}` },
    });
}

/** ========== Instances ========== **/
export function getInstancesStatus(token: string, tenantId: number) {
    return axios.get(`${API_V1_URL}/ctxr/-1/statusctxr?tenantId=${tenantId}`, {
        headers: { Authorization: `Bearer ${token}` },
    });
}

/** ========== HA ==========
 *  GET /ClusterCtxr/-1/list?tenantId=...
**/
export function getHAStatus(token: string, tenantId: number) {
    return axios.get(`${API_V1_URL}/ClusterCtxr/-1/list?tenantId=${tenantId}`, {
        headers: { Authorization: `Bearer ${token}` },
    });
}
